
define('tpl!ui/dateRange/tpl/select', ['handlebars'], function(hb){ 
return hb.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, functionType="function";


  buffer += "<div class=\"daterange\">\n    <label>"
    + escapeExpression((helper = helpers.__ || (depth0 && depth0.__),options={hash:{},data:data},helper ? helper.call(depth0, "From", options) : helperMissing.call(depth0, "__", "From", options)))
    + "</label><input type=\"text\" name=\"periodStart\" value=\"";
  if (helper = helpers.startDate) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.startDate); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"/>\n    <label>"
    + escapeExpression((helper = helpers.__ || (depth0 && depth0.__),options={hash:{},data:data},helper ? helper.call(depth0, "to", options) : helperMissing.call(depth0, "__", "to", options)))
    + "</label><input type=\"text\" name=\"periodEnd\" value=\"";
  if (helper = helpers.endDate) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.endDate); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"/>\n    <button class=\"small btn-info\" data-control=\"filter\" title=\""
    + escapeExpression((helper = helpers.__ || (depth0 && depth0.__),options={hash:{},data:data},helper ? helper.call(depth0, "Apply date range", options) : helperMissing.call(depth0, "__", "Apply date range", options)))
    + "\">\n        <span class=\"icon icon-filter\"></span> "
    + escapeExpression((helper = helpers.__ || (depth0 && depth0.__),options={hash:{},data:data},helper ? helper.call(depth0, "Apply", options) : helperMissing.call(depth0, "__", "Apply", options)))
    + "\n    </button>\n    <button class=\"small\" data-control=\"reset\">\n        <span class=\"icon icon-reset\"></span> "
    + escapeExpression((helper = helpers.__ || (depth0 && depth0.__),options={hash:{},data:data},helper ? helper.call(depth0, "Reset", options) : helperMissing.call(depth0, "__", "Reset", options)))
    + "\n    </button>\n</div>\n";
  return buffer;
  });
});

